import React from "react";
import PropTypes from "prop-types";
import classes from "./style/SearchInput.module.css";
import { Form } from "react-bootstrap";
import clsx from "clsx";

const SearchInput = ({ className, onChange, value, name }) => {
  return (
    <div className={clsx(className, "search position-relative")}>
      <span className={classes.searchIcon}>
        <i className="bi bi-search"></i>
      </span>
      <Form.Control
        type="text"
        id="searchForm"
        aria-describedby="searchForm"
        placeholder="Search..."
        className="pl-5 "
        name={name}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

/* required: display name */
SearchInput.displayName = "SearchInput";

/* required: props types */
SearchInput.propTypes = {};

/* required: default props */
SearchInput.defaultProps = {};

export { SearchInput };
